import { Button } from "@/base/components/index";
import { LocalizationText } from "@/app/index";
import { SyncIcon, RefreshIcon } from "@/base/static/index";

export const CheckboxGroupListActions = ({
  availableSelectValue,
  onClickUndoQuickSelect,
  onClickQuickSelect,
}: {
  availableSelectValue: boolean;
  onClickUndoQuickSelect: () => void;
  onClickQuickSelect: () => void;
}) => {
  return (
    <>
      {!availableSelectValue && (
        <Button
          variant="text"
          color="primary"
          icon={<RefreshIcon />}
          iconPosition="end"
          onClick={onClickUndoQuickSelect}
        >
          <LocalizationText value="widget.checkbox.group.list.button.undo.quick.select.text" />
        </Button>
      )}

      {availableSelectValue && (
        <Button
          variant="text"
          color="primary"
          icon={<SyncIcon rotate={90} />}
          iconPosition="end"
          onClick={onClickQuickSelect}
        >
          <LocalizationText value="widget.checkbox.group.list.button.quick.select.text" />
        </Button>
      )}
    </>
  );
};
